import React from 'react';
import ProductView from '../ProductHeaderView';
import main from '../../resource/lis/main.svg';

const Main = () => {
    return (
        <ProductView
            title="LIS"
            description="Cloud based. No requiere instalación y puede ser utilizado con recursos mínimos. Soportamos sistemas operativos Linux y Windows. Software de ultima generación pensado para cubrir todas las necesidades de tu laboratorio. Facilita la experiencia del usuario en cada etapa del proceso con un diseño amigable y moderno, acompañando el crecimiento de tu negocio."
            image={main} />
    );
};

export default Main;